import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';
export const deleteGroup = async (id) => {
  try {
    const response = await apiClient.delete(`/groups/deleteGroup/${id}`);

    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};
